import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { SLINKY, OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import { MERCURY_LAYER } from 'HubStyleTokens/sizes';
import { STAR_RATING, STAR_RATING_FILLED, STAR_RATING_EMPTY_STATE, RatingTypesTemplate } from '../constants/RatingTypes';
const backgroundPillStyles = css(["width:", "px;background-color:", ";border:2px solid ", ";border-radius:", ";"], ({
  disabled
}) => disabled ? 20 : 30, ({
  checked,
  disabled
}) => {
  if (checked) {
    return SLINKY;
  } else if (disabled) {
    return GREAT_WHITE;
  }

  return OLAF;
}, ({
  checked
}) => checked ? SLINKY : GREAT_WHITE, ({
  index
}) => {
  if (index === 1) {
    return '8px 0 0 8px';
  } else if (index === 5) {
    return '0 8px 8px 0';
  }

  return 0;
});
const foregroundPillStyles = css(["left:0;position:absolute;z-index:", ";background-color:", ";width:", ";"], MERCURY_LAYER, SLINKY, ({
  percentFilled,
  disabled
}) => `${percentFilled * (disabled ? 20 : 30) / 100}px`);
export const PillIcon = styled.div.withConfig({
  displayName: "AbstractRatingIcons__PillIcon",
  componentId: "ptghnj-0"
})(["height:", "px;margin:1px;border-radius:", ";", ";"], ({
  disabled
}) => disabled ? 8 : 15, ({
  index,
  percentFilled
}) => {
  let borderRadius = '0';

  if (index === 1) {
    borderRadius = '8px 0 0 8px';
  } else if (index === 5) {
    borderRadius = '0 8px 8px 0';
  }

  return !(percentFilled < 100 && index === 5) && borderRadius;
}, ({
  isForeground
}) => isForeground ? foregroundPillStyles : backgroundPillStyles);
const foregroundStarStyles = css(["left:0;overflow:hidden;position:absolute;z-index:", ";width:", ";"], MERCURY_LAYER, ({
  percentFilled
}) => `${percentFilled / 100}em`);
export const starRatingFactory = type => props => {
  const {
    isForeground,
    checked,
    className,
    size
  } = props;
  return /*#__PURE__*/_jsx(UIIcon, {
    color: RatingTypesTemplate[type][`${isForeground || checked ? 'checkedColor' : 'uncheckedColor'}`],
    name: RatingTypesTemplate[type][`${isForeground ? 'checkedIcon' : 'uncheckedIcon'}`],
    className: className,
    size: size
  });
};
const sharedStarStyles = 'line-height: 117%; margin-right: 0 !important;'; // These need to be separated out because the IconComponent that we pass
// into UIAbstractRatingInput must be a pure styled component, in order for
// hovering to work.

export const StarRating = styled(starRatingFactory(STAR_RATING)).withConfig({
  displayName: "AbstractRatingIcons__StarRating",
  componentId: "ptghnj-1"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');
export const StarRatingFilled = styled(starRatingFactory(STAR_RATING_FILLED)).withConfig({
  displayName: "AbstractRatingIcons__StarRatingFilled",
  componentId: "ptghnj-2"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');
export const StarRatingEmpty = styled(starRatingFactory(STAR_RATING_EMPTY_STATE)).withConfig({
  displayName: "AbstractRatingIcons__StarRatingEmpty",
  componentId: "ptghnj-3"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');